const thingsInternet = [
    {
        path: '/things-internet',
        name: 'thingsInternet',
        component: () => import('../views/thingsInternet/index.vue')
    },
   
]

export default thingsInternet